<template>
    <div>处理中。。。</div>
</template>
<script>
export default {
    data(){
        return {
            url:""
        }
    },
    created(){
        this.url = location.href;
        window.parent.wechatlogin(this.$route.query)
    }
}
</script>